import Vue from 'vue';

export default {
  setLoading(state, payload) {
    state.loading = payload;
  },

  setAllOrganization(state, payload) {
    state.allOrganization = payload;
  },

  setProxyOrganizations(state, payload) {
    state.proxyOrganizations = payload;
  },

  setOrganizationDetail(state, payload) {
    state.organizationDetailInfo = payload;
  },

  setOrganizationCourses(state, payload) {
    state.orgCourses = payload;
  },

  setViolations(state, payload) {
    state.violations = payload;
  },

  setAllFeedback(state, payload) {
    state.allFeedback = payload;
  },

  setFeedbackSummary(state, payload) {
    state.feedbackSummary = payload;
  },

  setViolationMetrics(state, payload) {
    state.violationMetrics = payload;
  },

  setViolationsNotified(state, payload) {
    state.violationsNotified = payload;
  },

  setViolationEvents(state, payload) {
    state.violationEvents = payload;
  },

  setDevices(state, payload) {
    state.devices = payload;
  },

  setBrowsers(state, payload) {
    state.browsers = payload;
  },

  setViolationFilters(state, payload) {
    for (const item of payload) {
      Vue.set(state.savedViolationFilters, item.id, item);
    }
  },

  setViolationFilterById(state, payload) {
    if (!payload.id) return;
    Vue.set(state.savedViolationFilters, payload.id, payload);
  },

  deleteViolationFilterById(state, id) {
    Vue.delete(state.savedViolationFilters, id);
  },

  setBlacklists(state, payload) {
    state.blacklists = payload;
  },

  setCourseUrlTypes(state, payload) {
    state.courseUrlTypes = payload;
  },

  setMessageDistributionLists(state, payload) {
    state.messageDistributionLists = payload;
  },

  setNumberOfaffectedUsers(state, payload) {
    state.numberOfaffectedUsers = payload.affectedUsers;
  },
  setPendingMessages(state, payload) {
    state.pendingMessages = payload;
  },
  setReleasedMessages(state, payload) {
    state.releasedMessages = payload;
  },

  setAccreditingEntities(state, payload) {
    state.accreditingEntities = payload;
  },
};
